module.exports = __webpack_public_path__ + "static/media/4.ab6a3214.png";